import { useRef, useEffect } from 'react';

const usePrevious = <T = any>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
